export default [
  {
    symbol: '©',
    entity: '&copy;',
    name: 'Copyright Sign',
    css: '\\00A9',
  },
  {
    symbol: '®',
    entity: '&reg;',
    name: 'Registered Trade Mark Sign',
    css: '\\00AE',
  },
  {
    symbol: '™',
    entity: '&trade;',
    name: 'Trade Mark Sign',
    css: '\\2122',
  },
  {
    symbol: '@',
    entity: '&commat;',
    name: 'At Symbol',
    css: '\\0040',
  },
  {
    symbol: '¶',
    entity: '&para;',
    name: 'Paragraph Sign',
    css: '\\00B6',
  },
  {
    symbol: '§',
    entity: '&sect;',
    name: 'Section Sign',
    css: '\\00A7',
  },
  {
    symbol: 'ℂ',
    entity: '&Copf;',
    name: 'Double-Struck Capital C',
    css: '\\2102',
  },
  {
    symbol: '℅',
    entity: '&incare;',
    name: 'Care Of',
    css: '\\2105',
  },
  {
    symbol: 'ℊ',
    entity: '&gscr;',
    name: 'Script Small G',
    css: '\\210A',
  },
  {
    symbol: 'ℋ',
    entity: '&hamilt;',
    name: 'Script Capital H',
    css: '\\210B',
  },
  {
    symbol: 'ℌ',
    entity: '&Hfr;',
    name: 'Black-Letter Capital H',
    css: '\\210C',
  },
  {
    symbol: 'ℍ',
    entity: '&Hopf;',
    name: 'Double-Struck Capital H',
    css: '\\210D',
  },
  {
    symbol: 'ℎ',
    entity: '&planckh;',
    name: 'Planck Constant',
    css: '\\210E',
  },
  {
    symbol: 'ℏ',
    entity: '&planck;',
    name: 'Planck Constant Over Two Pi',
    css: '\\210F',
  },
  {
    symbol: 'ℐ',
    entity: '&Iscr;',
    name: 'Script Capital I',
    css: '\\2110',
  },
  {
    symbol: 'ℑ',
    entity: '&image;',
    name: 'Black-Letter Capital I',
    css: '\\2111',
  },
  {
    symbol: 'ℒ',
    entity: '&Lscr;',
    name: 'Script Capital L',
    css: '\\2112',
  },
  {
    symbol: 'ℓ',
    entity: '&ell;',
    name: 'Script Small L',
    css: '\\2113',
  },
  {
    symbol: 'ℕ',
    entity: '&Nopf;',
    name: 'Double-Struck Capital N',
    css: '\\2115',
  },
  {
    symbol: '№',
    entity: '&numero;',
    name: 'Numero Sign',
    css: '\\2116',
  },
  {
    symbol: '℗',
    entity: '&copysr;',
    name: 'Sound Recording Copyright',
    css: '\\2117',
  },
  {
    symbol: '℘',
    entity: '&weierp;',
    name: 'Script Capital P',
    css: '\\2118',
  },
  {
    symbol: 'ℙ',
    entity: '&Popf;',
    name: 'Double-Struck Capital P',
    css: '\\2119',
  },
  {
    symbol: 'ℚ',
    entity: '&Qopf;',
    name: 'Double-Struck Capital Q',
    css: '\\211A',
  },
  {
    symbol: 'ℛ',
    entity: '&Rscr;',
    name: 'Script Capital R',
    css: '\\211B',
  },
  {
    symbol: 'ℜ',
    entity: '&real;',
    name: 'Black-Letter Capital R',
    css: '\\211C',
  },
  {
    symbol: 'ℝ',
    entity: '&Ropf;',
    name: 'Double-Struck Capital R',
    css: '\\211D',
  },
  {
    symbol: '℞',
    entity: '&rx;',
    name: 'Prescription Take',
    css: '\\211E',
  },
  {
    symbol: 'ℤ',
    entity: '&Zopf;',
    name: 'Double-Struck Capital Z',
    css: '\\2124',
  },
  {
    symbol: '℧',
    entity: '&mho;',
    name: 'Inverted Ohm Sign',
    css: '\\2127',
  },
  {
    symbol: 'ℨ',
    entity: '&Zfr;',
    name: 'Black-Letter Capital Z',
    css: '\\2128',
  },
  {
    symbol: '℩',
    entity: '&iiota;',
    name: 'Turned Greek Small Letter Iota',
    css: '\\2129',
  },
  {
    symbol: 'ℬ',
    entity: '&bernou;',
    name: 'Script Capital B',
    css: '\\212C',
  },
  {
    symbol: 'ℭ',
    entity: '&Cfr;',
    name: 'Black-Letter Capital C',
    css: '\\212D',
  },
  {
    symbol: 'ℯ',
    entity: '&escr;',
    name: 'Script Small E',
    css: '\\212F',
  },
  {
    symbol: 'ℰ',
    entity: '&Escr;',
    name: 'Script Capital E',
    css: '\\2130',
  },
  {
    symbol: 'ℱ',
    entity: '&Fscr;',
    name: 'Script Capital F',
    css: '\\2131',
  },
  {
    symbol: 'ℳ',
    entity: '&Mscr;',
    name: 'Script Capital M',
    css: '\\2133',
  },
  {
    symbol: 'ℴ',
    entity: '&oscr;',
    name: 'Script Small O',
    css: '\\2134',
  },
  {
    symbol: 'ℵ',
    entity: '&alefsym;',
    name: 'Alef Symbol',
    css: '\\2135',
  },
  {
    symbol: 'ℶ',
    entity: '&beth;',
    name: 'Bet Symbol',
    css: '\\2136',
  },
  {
    symbol: 'ℷ',
    entity: '&gimel;',
    name: 'Gimel Symbol',
    css: '\\2137',
  },
  {
    symbol: 'ℸ',
    entity: '&daleth;',
    name: 'Dalet Symbol',
    css: '\\2138',
  },
  {
    symbol: 'ⅅ',
    entity: '&DD;',
    name: 'Double-Struck Italic Capital D',
    css: '\\2145',
  },
  {
    symbol: 'ⅆ',
    entity: '&dd;',
    name: 'Double-Struck Italic Small D',
    css: '\\2146',
  },
  {
    symbol: 'ⅇ',
    entity: '&ee;',
    name: 'Double-Struck Italic Small E',
    css: '\\2147',
  },
  {
    symbol: 'ⅈ',
    entity: '&ii;',
    name: 'Double-Struck Italic Small I',
    css: '\\2148',
  },
  {
    symbol: '★',
    entity: '&starf;',
    name: 'Black Star',
    css: '\\2605',
  },
  {
    symbol: '☆',
    entity: '&star;',
    name: 'White Star',
    css: '\\2606',
  },
  {
    symbol: '☎',
    entity: '&phone;',
    name: 'Black Telephone',
    css: '\\260E',
  },
  {
    symbol: '♀',
    entity: '&female;',
    name: 'Female Sign',
    css: '\\2640',
  },
  {
    symbol: '♂',
    entity: '&male;',
    name: 'Male Sign',
    css: '\\2642',
  },
  {
    symbol: '♠',
    entity: '&spades;',
    name: 'Black Spade Suit',
    css: '\\2660',
  },
  {
    symbol: '♣',
    entity: '&clubs;',
    name: 'Black Club Suit',
    css: '\\2663',
  },
  {
    symbol: '♥',
    entity: '&hearts;',
    name: 'Black Heart Suit',
    css: '\\2665',
  },
  {
    symbol: '♦',
    entity: '&diams;',
    name: 'Black Diamond Suit',
    css: '\\2666',
  },
  {
    symbol: '♪',
    entity: '&sung;',
    name: 'Eighth Note',
    css: '\\266A',
  },
  {
    symbol: '♭',
    entity: '&flat;',
    name: 'Music Flat Sign',
    css: '\\266D',
  },
  {
    symbol: '♮',
    entity: '&natural;',
    name: 'Music Natural Sign',
    css: '\\266E',
  },
  {
    symbol: '♯',
    entity: '&sharp;',
    name: 'Music Sharp Sign',
    css: '\\266F',
  },
  {
    symbol: '✓',
    entity: '&check;',
    name: 'Check Mark',
    css: '\\2713',
  },
  {
    symbol: '✗',
    entity: '&cross;',
    name: 'Ballot X',
    css: '\\2717',
  },
  {
    symbol: '✠',
    entity: '&malt;',
    name: 'Maltese Cross',
    css: '\\2720',
  },
  {
    symbol: '✶',
    entity: '&sext;',
    name: 'Six Pointed Black Star',
    css: '\\2736',
  },
  {
    symbol: '❘',
    entity: '&VerticalSeparator;',
    name: 'Light Vertical Bar',
    css: '\\2758',
  },
  {
    symbol: '❲',
    entity: '&lbbrk;',
    name: 'Light Left Tortoise Shell Bracket Ornament',
    css: '\\2772',
  },
  {
    symbol: '❳',
    entity: '&rbbrk;',
    name: 'Light Right Tortoise Shell Bracket Ornament',
    css: '\\2773',
  },
];
